const common = {
  siteName: 'BB彩票平台APP',
  siteSlogan: '正规彩票购买软件官方下载',
  navHome: '首页',
  navLottery: '彩票大厅',
  navArticle: '彩票资讯',
  navAbout: '关于我们',
  navDownload: 'APP下载',
  breadcrumbHome: '首页',
  footerCopyright: '© 2024 BB彩票平台APP 版权所有',
  footerDisclaimer: '购彩有风险，投注需谨慎。未满18周岁不得购买彩票。',
  footerLinks: '相关链接',
  footerContact: '联系我们',
  readMore: '阅读全文',
  viewAll: '查看全部',
  downloadApp: '立即下载',
  contactUs: '联系我们',
  submit: '提交',
  phone: '客服热线',
  email: '电子邮箱',
  address: '公司地址',
};

export default common;